module.exports = __webpack_public_path__ + "img/1521492223.0c3fd2dc.jpg";